<template>
    <el-dialog
        :visible.sync="show"
        title="选择人员"
        :lock-scroll="false"
        append-to-body
        custom-class="m-dialog"
        width="80%"
    >
        <div class="xy-between al-start" v-loading="loading">
            <!-- 部门选择 -->
            <div class="mb-10 no-shrink" style="width: 200px;padding-right: 15px">
                <div class="c-868EA1 mb-10 text-center">用户组选择</div>
                <!--el-cascader
                    v-model="groupSelect"
                    :options="userGroup"
                    :props="{ multiple: true, checkStrictly: true }"
                    clearable>
                    <template v-slot="{ node, data }">
                        <span @click="groupChange(data)">{{ data.label }}</span>
                    </template>
                </el-cascader-->
                <el-tree
                    ref="elTree"
                    :data="userGroup"
                    show-checkbox
                    node-key="ID"
                    :props="{children: 'children',label: 'Name'}"
                >
                    <span class="custom-tree-node" slot-scope="{ node, data }">
                        <span>{{ node.label }}</span>
                        <el-button
                            type="text"
                            size="mini"
                            @click.stop="() => groupChange(data)">
                            选人
                        </el-button>
                    </span>
                </el-tree>
            </div>
            <!-- 部门下的人员选择 -->
            <div class="auto-grow table">
                <div class="c-868EA1 mb-10 text-center">点击用户组 选人 按钮选择用户</div>
                <el-table :data="userList" width="100%" border
                          @select="onSelect"
                          @select-all="onSelectAll"
                          ref="table"
                >
                    <el-table-column
                        type="selection"
                        width="55">
                    </el-table-column>
                    <el-table-column label="真实姓名" prop="RealName"></el-table-column>
                    <el-table-column label="账号" prop="UserName"></el-table-column>
                    <el-table-column label="电话" prop="Telephone"></el-table-column>
                    <el-table-column label="所属用户组" prop="GroupName" :formatter="defaultVal"></el-table-column>
                </el-table>
                <div class="xy-center mt-17 mb-10">
                    <el-pagination
                        @current-change="loadMembers"
                        @size-change="loadMembers(true)"
                        :current-page.sync="memberQuery.pageNo"
                        :page-size.sync="memberQuery.pageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total">
                    </el-pagination>
                </div>
            </div>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button @click="show = false">取 消</el-button>
            <el-button type="primary" @click="save">确 定</el-button>
        </span>
    </el-dialog>
</template>

<script>
import { fetchOrgInfo, GetCandidate } from "@/api/manage";

export default {
    name: "SelectMemberDialog",
    props: {
        selectedGroup: {
            type: Array,
            default: () => []
        },
        selectedMember: {
            type: Array,
            default() {
                return []
            }
        },
    },
    data() {
        return {
            show: false,
            list: [],
            loading: false,
            userList: [],
            userSelect: [],
            userGroup: [],
            total: 0,
            memberQuery: {
                pageNo: 1,
                pageSize: 10,
                currentGroup: "",
            }
        }
    },
    methods: {
        open() {
            this.show = true;
            this.userSelect = Array.from(this.selectedMember)
            if (this.userList.length > 0) {
                this.refreshSelect()
            }
            this.loadData(true).then(() => {
                this.$refs.elTree.setCheckedKeys(this.selectedGroup)
            });
        },
        loadData(init) {
            this.loading = true;
            return Promise.all([
                this.loadGroup()
            ]).finally(() => {
                this.loading = false;
            })
        },
        // 点击用户组名
        groupChange(node) {
            console.log(node)
            this.memberQuery.currentGroup = node.ID
            this.loadMembers(true)
        },
        defaultVal(row, column, cellValue, index) {
            if (cellValue == null || cellValue === "" || cellValue.length === 0 || cellValue === "1753-01-01 00:00:00") {
                return "--"
            } else {
                return cellValue
            }
        },
        loadMembers(refresh) {
            if (refresh === true) {
                this.memberQuery.pageNo = 1
            }
            this.loading = true;
            GetCandidate({
                OrganGroupId: this.memberQuery.currentGroup,
                pageNo: this.memberQuery.pageNo,
                pageSize: this.memberQuery.pageSize
            }).then(({ data }) => {
                this.loading = false
                this.userList = data.data
                this.total = data.count
                this.refreshSelect();
            })
        },
        // 刷新选择状态
        refreshSelect() {
            this.$nextTick(() => {
                this.userList.forEach(el => {
                    let inSelected = this.userSelect.some(select => select.UserId === el.UserId)
                    if (inSelected) {
                        this.$refs.table.toggleRowSelection(el, true)
                    } else {
                        this.$refs.table.toggleRowSelection(el, false)
                    }
                })
            })
        },
        // 用户点击选中切换
        onSelect(selection, row) {
            let index = this.userSelect.findIndex(el => el.UserId === row.UserId)
            if (index > -1) {
                this.userSelect.splice(index, 1)
            } else {
                this.userSelect.push(row)
            }
        },
        // 用户点击全选
        onSelectAll(selection) {
            if (selection.length > 0) {
                // 全选
                selection.forEach(row => {
                    let index = this.userSelect.findIndex(el => el.UserId === row.UserId)
                    if (index < 0) {
                        this.userSelect.push(row)
                    }
                })
            } else {
                // 取消全选
                this.list.forEach(row => {
                    let index = this.userSelect.findIndex(el => el.UserId === row.UserId)
                    if (index > -1) {
                        this.userSelect.splice(index, 1)
                    }
                })
            }
        },
        async loadGroup() {
            if (this.userGroup.length) return;
            await fetchOrgInfo().then((res) => {
                this.userGroup = res;
            });
        },
        save() {
            let selectG = this.$refs.elTree.getCheckedNodes(true)
            this.show = false;
            this.$emit("select-user", this.userSelect)
            this.$emit("select-group", selectG)
        }
    }
}
</script>

<style scoped lang="less">

.table {
    border-left: 1px solid #cccccc;
    padding-left: 30px;
}

.custom-tree-node {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    padding-right: 8px;
}
</style>
